export {}

const textAndMediaSliderGroups = document.querySelectorAll<HTMLElement>(".g-text-and-media-slider")

textAndMediaSliderGroups.forEach(group => {
  const prevButton = group.querySelector<HTMLElement>(".g-text-and-media-slider__button.--prev")
  const nextButton = group.querySelector<HTMLElement>(".g-text-and-media-slider__button.--next")

  const medias = group.querySelectorAll<HTMLElement>(".g-text-and-media-slider__media-item")
  const contents = group.querySelectorAll<HTMLElement>(".g-text-and-media-slider__content-item")

  if (!prevButton || !nextButton) return

  const numberOfItems = parseInt(group.dataset.items ?? "0")
  if (!numberOfItems) return

  let activeIndex = 0
  let delay = false

  const openGroupItem = (index: number) => {
    medias.forEach(media => {
      media.classList.toggle("--open", media.dataset.index === `${index}`)
    })

    contents.forEach(content => {
      content.classList.toggle("--open", content.dataset.index === `${index}`)
    })

    delay = true
    setTimeout(() => delay = false, 500)
  }

  prevButton.addEventListener("click", (e) => {
    e.preventDefault()
    if (delay) return
    if (activeIndex == 0) activeIndex = numberOfItems - 1
    else activeIndex--
    openGroupItem(activeIndex)
  })

  nextButton.addEventListener("click", (e) => {
    e.preventDefault()
    if (delay) return
    if (activeIndex == numberOfItems - 1) activeIndex = 0
    else activeIndex++
    openGroupItem(activeIndex)
  })

  contents.forEach(content => {
    content.addEventListener("click", () => {
      if (delay) return
      if (content.classList.contains("--open")) return
      activeIndex = parseInt(content.dataset.index ?? "0")
      openGroupItem(activeIndex)
    })
  })

  openGroupItem(activeIndex)
})
